import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from 'src/app/app-config.loader';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(    private router: Router,
    private appConfig: AppConfig) { }

  ngOnInit() {
    void this.router.navigate([this.appConfig.logic.defaultRoot]);
    return;

  }

}
